export const download_fields = [
  // { field: 'cca_uid', name: 'UID' },
  { field: 'about', name: 'About' },
  { field: 'title', name: 'Title' },
  { field: 'created', name: 'Creation Date' },
  { field: 'issued', name: 'Publication Date' },
  { field: 'creators', name: 'Creator' },
  { field: 'objectProvides', name: 'Content type' },
  { field: 'cca_keywords', name: 'Keywords' },
  { field: 'cca_adaptation_sectors', name: 'Sectors' },
  { field: 'cca_climate_impacts', name: 'Climate impact' },
  { field: 'transnational_regions', name: 'Transnational regions' },
  { field: 'cca_adaptation_elements', name: 'Adaptation Approaches' },
  { field: 'cca_funding_programme', name: 'Funding programme' },
  { field: 'cca_key_type_measure', name: 'Key type measure' },
  { field: 'cca_geographic_countries', name: 'Countries' },
  { field: 'cca_origin_websites', name: 'Origin website' },
  { field: 'cca_health_impacts', name: 'Health impacts' },
  { field: 'cca_partner_contributors', name: 'Observatory impacts' },
  // { field: 'fulltext', name: 'Description' },
];

export const eea_languages = [
  { name: 'English', code: 'en' },
  { name: 'български', code: 'bg' },
  { name: 'Español', code: 'es' },
  // { name: 'Čeština', code: 'cs' },
  { name: 'Dansk', code: 'da' },
  { name: 'Deutsch', code: 'de' },
  // { name: 'Eesti keel', code: 'et' },
  { name: 'Ελληνικά', code: 'el' },
  { name: 'Français', code: 'fr' },
  // { name: 'Gaeilge', code: 'ga' },
  { name: 'Hrvatski', code: 'hr' },
  { name: 'Italiano', code: 'it' },
  // { name: 'Latviešu valoda', code: 'lv' },
  // { name: 'Lietuvių kalba', code: 'lt' },
  // { name: 'Magyar', code: 'hu' },
  // { name: 'Malti', code: 'mt' },
  // { name: 'Nederlands', code: 'nl' },
  { name: 'Polski', code: 'pl' },
  { name: 'Português', code: 'pt' },
  { name: 'Română', code: 'ro' },
  // { name: 'Slovenčina', code: 'sk' },
  // { name: 'Slovenščina', code: 'sl' },
  { name: 'Suomi', code: 'fi' },
  { name: 'Svenska', code: 'sv' },
  { name: 'Íslenska', code: 'is' },
  { name: 'Nynorsk', code: 'nn' },
  // { name: 'Türkçe', code: 'tr' },
];
